import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f9b2699e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tools"
}
const _hoisted_2 = { class: "albums" }
const _hoisted_3 = { class: "album-item" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon i-bofang play" })
], -1))
const _hoisted_6 = { class: "tip" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { class: "del" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 1,
  class: "not-found c-thirdary"
}

import device from '@/store/device';
import playbacks, { State } from '@/store/mine/playbacks';
import * as filters from '@/views/filters';
import * as links from '@/views/links';
import { computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import Album from '../../movies/albums/Album.vue';
import i18, { State as I18State } from '@/store/i18';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const router = useRouter()
const data = computed<State>(() => store.state[playbacks.name])

const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].mineText)

onMounted(() => {
    playbacks.loadList(store)
})

function onGo(item: Playback) {
    router.push(links.player(item.movid, item.urlid, item.duration))
}

async function onRemove(item: Playback, i: number) {
    try {
        await playbacks.remove(store, i)
    } catch (e) {
        device.toast(store, lang.value.errorDelete)
    }
}
async function onClear() {
    try {
        await playbacks.clear(store)
    } catch (e) {
        device.toast(store, lang.value.errorClear)
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(data).list.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("a", {
            class: "link",
            onClick: onClear
          }, _toDisplayString(_unref(lang).clear), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).list, (item, i) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(Album, {
            album: item.movie
          }, null, 8, ["album"]),
          _createElementVNode("div", {
            class: "mask",
            onClick: ($event: any) => (onGo(item))
          }, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createTextVNode(_toDisplayString(item.url.title) + " ", 1),
              _hoisted_7,
              _createTextVNode(" " + _toDisplayString(_unref(filters).leftTime(item.duration)), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("a", {
                onClick: _withModifiers(($event: any) => (onRemove(item, i)), ["stop"])
              }, _toDisplayString(_unref(lang).delete), 9, _hoisted_9)
            ])
          ], 8, _hoisted_4)
        ]))
      }), 256))
    ]),
    (_unref(data).list.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(lang).empty), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})